export const CHANGE_NAV = 'CHANGE_NAV';


// WEBPACK FOOTER //
// ./src/store/type.js